import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { SVGIcon } from 'ic-snacks'
import { useBooleanState, Modal, Text } from '@retailer-platform/shared-components'
import Card from 'legacy/components/Card/Card'
import { useDashMessage } from 'intl/intl.hooks'
import { type DashMessages } from 'intl/intl.types'

const tooltipTrigger = css({
  fontSize: '12px',
  marginLeft: '5px',
})

const tooltipTriggerContainer = css({
  alignItems: 'center',
  display: 'flex',
  backgroundColor: 'Transparent',
})

export type Props = {
  titleId: DashMessages
  titleSuffix?: string
  tooltipId?: DashMessages
  renderAction?: boolean
}

export const MerchandisingFormSection: FunctionComponent<Props> = ({
  renderAction,
  children,
  titleId,
  titleSuffix = '',
  tooltipId,
}) => {
  const title = useDashMessage(titleId)
  const tooltip = useDashMessage(tooltipId)
  const tooltipTriggerText = useDashMessage('merchandising.hero-banners.section.tooltip.trigger')
  const [tooltipOpen, showTooltip, hideTooltip] = useBooleanState()

  return (
    <Card margin="0 0 32px 0">
      <Card.Header title={title + titleSuffix}>
        {renderAction && (
          <button onClick={showTooltip} css={tooltipTriggerContainer}>
            <SVGIcon name="infoFilled" size="small" />
            <span css={tooltipTrigger}>{tooltipTriggerText}</span>
          </button>
        )}
      </Card.Header>
      <Card.Body>{children}</Card.Body>
      <Modal
        isOpen={tooltipOpen}
        headerContent={
          <Text size="large" weight="bold">
            {title}
          </Text>
        }
        bodyContent={<Text>{tooltip}</Text>}
        onRequestClose={hideTooltip}
      />
    </Card>
  )
}
